/**
 * Alaska Gift — Contact Form
 * Phone number formatting for the contact form.
 */

(() => {
  const phone = document.getElementById('ContactForm-phone');
  if (!phone) return;

  phone.addEventListener('input', () => {
    const digits = phone.value.replace(/\D/g, '').slice(0, 10);
    if (digits.length === 0) { phone.value = ''; return; }
    let formatted = '(';
    formatted += digits.slice(0, 3);
    if (digits.length >= 4) formatted += ') ' + digits.slice(3, 6);
    else formatted += ')';
    if (digits.length >= 7) formatted += '-' + digits.slice(6);
    phone.value = formatted;
  });
})();
